import React from 'react';
import Nav from 'components/nav'
import Form from 'components/form'
import CashflowGrandTotal from 'components/form/cashflow/grand-total'
import AssetsGrandTotal from 'components/form/assets/grand-total'
import Menu from 'components/menu'
import WP_DATA from 'utils/wp_data'

function App() {
  return (
    <>
      <Menu/>
      { WP_DATA.worksheet_type === 'cashflow-analysis'
        ? <CashflowGrandTotal />
        : <AssetsGrandTotal /> }
      <Nav />
      <Form />
    </>
  );
}

export default App;
